import { useEffect, useState } from 'react'

import { Col, Form, OverlayTrigger, Row, Tooltip } from 'react-bootstrap'
import { ArrowRightCircleFill } from 'react-bootstrap-icons'
import { toast } from 'react-toastify'

import TiposService from '../../../../../services/database/TiposService'

import {
  ContainerComponent,
  ContentComponent,
  FooterComponent,
  NextButton,
} from '../../styles'
import { CustomSpinner } from '../../../../CustomSpinner'

export function DadosPISCOFINS({ isVisible, onNext, product, handleChange }) {
  const [tipos, setTipos] = useState([])
  const [isLoadingTypes, setIsLoadingTypes] = useState(true)

  async function loadTypes() {
    try {
      setIsLoadingTypes(true)
      const tipos = await TiposService.getAll()

      setTipos(tipos)
    } catch (err) {
      console.log(`Erro ao carregar tipos: ${err}`)
      toast.error('Erro ao carregar os tipos!')
    } finally {
      setIsLoadingTypes(false)
    }
  }

  useEffect(() => {
    if (isVisible) {
      loadTypes()
    }
  }, [isVisible])

  if (!isVisible) {
    return null
  }

  return (
    <ContainerComponent>
      <div>
        <ContentComponent>
          <h4>Dados PIS & COFINS</h4>

          <Row className="mb-3">
            <Col>
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 5,
                }}
              >
                <Form.Label
                  style={{
                    margin: 0,
                  }}
                >
                  CST PIS
                </Form.Label>

                {isLoadingTypes && <CustomSpinner size={18} />}
              </div>

              <Form.Select
                name="CSTPIS"
                value={product.CSTPIS}
                onChange={(e) => handleChange(e, 'pisCofins')}
                disabled={isLoadingTypes}
                style={{
                  marginTop: 8,
                }}
              >
                <option value="">
                  {isLoadingTypes ? 'Carregando ...' : 'Selecione uma Opção'}
                </option>
                {tipos
                  .filter((tipo) => tipo.TIPO === 'CSOSN')
                  .map((tipo) => (
                    <option
                      key={tipo.ID}
                      value={tipo.CODIGO}
                    >
                      {tipo.DESCRICAO}
                    </option>
                  ))}
              </Form.Select>
            </Col>

            <Col>
              <Form.Label>% PIS</Form.Label>
              <Form.Control
                name="PIS"
                value={product.PIS}
                onChange={(e) => handleChange(e, 'pisCofins')}
              />
            </Col>
          </Row>

          <Row className="mb-3">
            <Col>
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 5,
                }}
              >
                <Form.Label
                  style={{
                    margin: 0,
                  }}
                >
                  CST COFINS
                </Form.Label>

                {isLoadingTypes && <CustomSpinner size={18} />}
              </div>

              <Form.Select
                name="CSTCOFINS"
                value={product.CSTCOFINS}
                onChange={(e) => handleChange(e, 'pisCofins')}
                disabled={isLoadingTypes}
                style={{
                  marginTop: 8,
                }}
              >
                <option value="">
                  {isLoadingTypes ? 'Carregando...' : 'Selecione uma Opção'}
                </option>
                {tipos
                  .filter((tipo) => tipo.TIPO === 'CST COFINS')
                  .map((tipo) => (
                    <option
                      key={tipo.ID}
                      value={tipo.CODIGO}
                    >
                      {tipo.DESCRICAO}
                    </option>
                  ))}
              </Form.Select>
            </Col>

            <Col>
              <Form.Label>% COFINS</Form.Label>
              <Form.Control
                name="COFINS"
                value={product.COFINS}
                onChange={(e) => handleChange(e, 'pisCofins')}
              />
            </Col>
          </Row>
        </ContentComponent>

        <FooterComponent>
          <OverlayTrigger overlay={<Tooltip>Avançar</Tooltip>}>
            <NextButton onClick={onNext}>
              <ArrowRightCircleFill
                size={15}
                color="white"
              />
            </NextButton>
          </OverlayTrigger>
        </FooterComponent>
      </div>
    </ContainerComponent>
  )
}
